import React from 'react'

const EmailCampaign = () => {
  return (
    <div>EmailCampaign</div>
  )
}

export default EmailCampaign